import styled from "styled-components";
import { TextXS } from "../Typography/Typography";

const Error = styled.p`
  ${TextXS};
  color: red;
`;

export default Error;
